import React from "react";
import "../styles/Section7.css";

function Section7()
{
    return(<>

<div class="container-fluid sect7">
   <div class="col-lg-12 py-lg-5">     {/*  or <div className="row"></div> */}
   <div className="row">
    <div class="d-flex flex-column justify-content-Center col-lg col-2 my-3 px-sm-4 mx-lg-1 sect7img">
      <img src={require('../images/image.png')} alt="" className="img-fluid "  />
      <div className="">RESIDENCE</div>
    </div>
    <div class="d-flex flex-column justify-content-center col-lg col-2 my-3 mx-lg-1  px-sm-4 sect7img">
    <img src={require('../images/sec7img2.png')} alt="" className="img-fluid sect7image" />
    <div className="">ECO LIVING </div>
    </div>
    <div class="d-flex flex-column justify-content-center col-lg col-2 my-3 mx-lg-1 px-sm-4 sect7img">
    <img src={require('../images/sec7img3.png')} alt="" className="img-fluid sect7image" />
    <div className="">QUALITY </div>
    </div>
    <div class="d-flex flex-column justify-content-center col-lg col-2 my-3 mx-lg-1 px-sm-4 sect7img">
    <img src={require('../images/sec7img4.png')} alt="" className="img-fluid sect7image" />
    <div className="">INFO DESK </div>
    </div>
    <div class="d-flex flex-column justify-content-center col-lg col-2 my-3 mx-lg-1 px-sm-4 sect7img">
    <img src={require('../images/sec7img5.png')} alt="" className="img-fluid sect7image" />
    <div className="">RECEPTION </div>
    </div>
    <div class="d-flex flex-column justify-content-center col-lg col-2 my-3 mx-lg-1 px-sm-4 sect7img">
    <img src={require('../images/sec7img6.png')} alt=""  className="img-fluid sect7image"/>
    <div className="">HELP </div>
    </div>
  </div>
  </div>
</div>
   
    
    </>)
}

export default Section7;